import * as R from 'ramda';
export function filterBySubstring(substring, arr) {
    return R.pipe(R.defaultTo([]), R.filter(R.includes(substring)))(arr);
}
